import { render } from "./LinkButton.vue?vue&type=template&id=0146886c&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"

import "./LinkButton.vue?vue&type=style&index=0&id=0146886c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0146886c"]])

export default __exports__